module.exports = __webpack_public_path__ + "components/flag/static/square/pw-5957a8fdc28d9d5ef3e86bdbfb511a17.svg";